<div class="chart-holder" style="background: #161616;">
  <ng-select [(ngModel)]="selectedYear" placeholder="Choose a year" [searchable]="false" [clearable]="false"
    (change)="selectYear($event)"
    style="position: absolute; right: 40px; top: 55px; z-index: 1; font-size: 12px; width: 100px">
    <ng-option *ngFor="let year of years" [value]=year.value>{{year.desc}}</ng-option>
  </ng-select>
  <div #myCharts echarts [options]="chartOption" class="demo-chart" (chartInit)="onChartInit($event)"></div>
</div>